import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PlayCircle, ArrowRight } from "lucide-react";
import { api } from "../lib/api";
import { BeltBadge } from "./common";

const resumeLink = (r) => `/app/learn/${r.course_slug}?module=${r.point.module_index}&part=${r.point.part_index ?? 0}`;

const label = (r) => {
  if (r.point.module_title === "Final exam") return "All sessions done - take your final exam";
  const where = r.point.part_title ? `${r.point.part_title} of "${r.point.module_title}"` : `the session quiz for "${r.point.module_title}"`;
  return r.started ? `You stopped at ${where}` : `Start with ${where}`;
};

export const ContinueLearning = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/my/resume-point").then((r) => setRows(r.data)).catch(() => {}); }, []);
  if (!rows.length) return null;
  return (
    <div className="space-y-3 mb-6" data-testid="continue-learning">
      {rows.map((r) => {
        const pct = r.total_parts ? Math.round((r.parts_done / r.total_parts) * 100) : Math.round((r.modules_done / (r.total_modules || 1)) * 100);
        return (
          <div key={r.course_slug} className="dx-card p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center gap-4 border-l-4 border-l-[#D4AF37]" data-testid={`continue-${r.course_slug}`}>
            <div className="w-12 h-12 rounded-full bg-[#5B2A6E] grid place-items-center shrink-0"><PlayCircle className="w-6 h-6 text-[#D4AF37]" /></div>
            <div className="flex-1 min-w-0">
              <div className="flex flex-wrap items-center gap-2"><span className="dx-eyebrow">{r.started ? "Pick up where you left off" : "Ready when you are"}</span><BeltBadge belt={r.belt} /></div>
              <div className="font-display font-semibold mt-1 truncate">{r.course_title}</div>
              <div className="text-sm text-[#6b5a73]" data-testid={`continue-${r.course_slug}-point`}>{label(r)}</div>
              <div className="mt-2 flex items-center gap-2">
                <div className="h-1.5 flex-1 max-w-xs rounded bg-[#F4EEF7]"><div className="h-1.5 rounded bg-[#5B2A6E]" style={{ width: `${pct}%` }} /></div>
                <span className="text-xs text-[#8a7a92]">{r.total_parts ? `${r.parts_done}/${r.total_parts} parts` : `${r.modules_done}/${r.total_modules} sessions`}</span>
              </div>
            </div>
            <Link to={resumeLink(r)} className="dx-btn-gold shrink-0" data-testid={`continue-${r.course_slug}-btn`}>{r.started ? "Resume" : "Start"} <ArrowRight className="w-4 h-4" /></Link>
          </div>
        );
      })}
    </div>
  );
};
